// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FK5o","delete":"styles_delete__3Tjxv","update":"styles_update__TlT6v","add":"styles_add__1lplx"};